import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { CalendarDay } from 'further-ui/utils';
import { round, sumBy } from 'lodash';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { UpdateCapitalActionFormValues } from '../../hooks/useCapitalActionForm';
import useTransactionTypes from './useTransactionTypes';

export default function useReviewDetails({
  capitalActionId,
  entries,
  vehicleId,
  date,
}: {
  capitalActionId?: string;
  entries: UpdateCapitalActionFormValues['entries'];
  vehicleId: string;
  date: CalendarDay;
}) {
  const { setValue } = useFormContext<UpdateCapitalActionFormValues>();

  const { transactionTypes, investorsBreakdown, isLoading } =
    useTransactionTypes({
      capitalActionId,
      vehicleId,
      entries: entries ?? [],
      date,
    });

  useEffect(() => {
    setValue('transactions', transactionTypes);
  }, [transactionTypes]);

  const totalCapitalContributionUsed = sumBy(
    investorsBreakdown,
    'capitalContributionUsed',
  );

  const totalAmount = round(
    sumBy(entries, (entry) => {
      if (
        [
          CapitalActionEntryType.CapitalRefund,
          CapitalActionEntryType.CapitalDistribution,
        ].includes(entry.entryType)
      ) {
        return -entry.totalAmountLcy;
      }

      return entry.totalAmountLcy;
    }) - totalCapitalContributionUsed,
    2,
  );

  return {
    transactionTypes,
    investorsBreakdown,
    totalAmount,
    isLoading,
  };
}
